package co.maytes.standupbot.dashboard.features.templates

import co.maytes.standupbot.shared.template.LinearActivityBundle
import co.maytes.standupbot.shared.template.WorkWindowVars
import kotlinx.datetime.LocalDate

object PromptFixture {
    val workWindow: WorkWindowVars = WorkWindowVars(
        label = "yesterday",
        date = LocalDate(2026, 4, 24),
        daysBack = 1,
    )

    val eventsBlock: String =
        """
        - 09:30–10:00 · Standup sync @ Zoom
        - 14:00–15:00 · Architecture review @ Boardroom
        """.trimIndent()

    fun bundle(workspaceName: String = "Your workspace"): LinearActivityBundle = LinearActivityBundle(
        workspaceName = workspaceName,
        standupName = "Platform",
        users = listOf(
            LinearActivityBundle.UserActivity(
                name = "Alex",
                yesterday = listOf("ENG-482 shipped auth rate-limit", "Code-reviewed PR #217"),
                today = listOf("ENG-491 finish OAuth refresh edge-cases"),
                blockers = emptyList(),
            ),
            LinearActivityBundle.UserActivity(
                name = "Priya",
                yesterday = listOf("ENG-475 debugged flaky Slack webhook test"),
                today = listOf("ENG-492 pairing with Alex on refresh", "Draft RFC for batch ingest"),
                blockers = listOf("Waiting on Linear scope approval for projects:read"),
            ),
            LinearActivityBundle.UserActivity(
                name = "Dmitri",
                yesterday = listOf("ENG-470 migration review + deploy to staging"),
                today = listOf("ENG-493 observe staging for 24h before prod cut"),
                blockers = emptyList(),
            ),
            LinearActivityBundle.UserActivity(
                name = "Sam",
                yesterday = emptyList(),
                today = listOf("ENG-494 wire up new dashboard templates page"),
                blockers = listOf("Figma file access request still pending"),
            ),
        ),
    )
}
